<app-slider></app-slider>
<app-services></app-services>
<app-achievement></app-achievement>
<div class="bg-gray">
    <div class="row">
    <div class="column medium-6" style="text-align: right; padding:5% 10% 5% 10%">
        <img src="../../assets/images/portfolio-desc-img.png" alt="لیما">

    </div>
    <div class="column medium-6 lima-button" style="text-align: right; padding-right: 10%;">
        <h3><strong>
            سامانه لیما
        </strong></h3>
        <h5 style="padding-top: 10px;padding-bottom: 10px;">ابزار لازم برای یک سرمایه‌گذاری صحیح</h5>
        <ul style="list-style: none;font-size: 13px;">
            <li>امکان مقایسه صندوق‌های سرمایه‌گذاری برای تصمیم‌گیری بهتر</li>
            <li>تشکیل یک سبد دارایی مناسب از صندوق‌های مختلف</li>
            <li>گزارش‌های متنوع عملکرد سرمایه‌گذاری و تراکنش‌های مالی</li>
            <li>ابطال واحد صندوق‌ها و برداشت آسان از حساب</li>
            <li>تیم مشاوره و پشتیبانی مجرب</li>
        </ul>

        
            <a class="wpfs button " target="_blank" href="https://lima.ir"> ورود به سامانه لیما</a>

    </div>
</div>
</div>
<!-- <app-new-solutions></app-new-solutions> -->
<app-new-investments></app-new-investments>